function detectPlatform() {
  return window.innerWidth <= 767 ? "mweb" : "web"
}

export default detectPlatform
